var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import AntModal from "antd/es/modal";
import classNames from "classnames";
import { CancelIcon } from "../../Icons";
import { IconSizes } from "../../Icons/PropTypes/IconSizes";
import ButtonGroup from "../../Button/ButtonGroup";
import { Button, ButtonSize, ButtonTypes } from "../../Button";
import { useGlobalTranslations } from "../../hooks/useTranslations";
const LegacyModal = (_a) => {
    var { cancelText, centered, children, className, closable = true, wrapClassName, onCancel, title, visible, actions, cancelButtonProps, isReactToolbox, okButtonProps, okText, onOk, hideFooter, getGerudoContainer, "data-testid": dataTestId = "gerudo-modal-test" } = _a, props = __rest(_a, ["cancelText", "centered", "children", "className", "closable", "wrapClassName", "onCancel", "title", "visible", "actions", "cancelButtonProps", "isReactToolbox", "okButtonProps", "okText", "onOk", "hideFooter", "getGerudoContainer", "data-testid"]);
    const t = useGlobalTranslations();
    return (React.createElement(AntModal, Object.assign({ visible: visible, wrapClassName: wrapClassName, title: title, onCancel: onCancel, onOk: onOk, closable: closable, centered: isReactToolbox || centered, getContainer: () => {
            return getGerudoContainer();
        }, modalRender: () => {
            return (React.createElement("div", { "data-testid": dataTestId, className: classNames("ant-modal-content", "gerudo-modal-content", "gerudo-modal-content-legacy", className, {
                    "gerudo-react-toolbox": isReactToolbox,
                    "gerudo-modal-content-no-footer": hideFooter,
                }) },
                closable && (React.createElement("button", { type: "button", "aria-label": t("close"), className: "ant-modal-close", onClick: onCancel },
                    React.createElement("span", { className: "ant-modal-close-x" },
                        React.createElement("span", { className: "anticon anticon-close ant-modal-close-icon" },
                            React.createElement(CancelIcon, { size: IconSizes.Medium }))))),
                title && (React.createElement("div", { className: "gerudo-modal-header ant-modal-header" },
                    React.createElement("div", { className: "ant-modal-title" }, title))),
                React.createElement("div", { className: "gerudo-modal-body ant-modal-body" }, children),
                !hideFooter && (React.createElement("div", { className: "gerudo-modal-footer ant-modal-footer" }, actions ? (actions(onCancel, onOk)) : (React.createElement(ButtonGroup, { size: ButtonSize.Small },
                    React.createElement(Button, Object.assign({ type: ButtonTypes.Default, onClick: onOk }, okButtonProps), okText || "Ok"),
                    React.createElement(Button, Object.assign({ type: ButtonTypes.Text, onClick: onCancel }, cancelButtonProps), cancelText || "Cancel")))))));
        } }, props), children));
};
LegacyModal.confirm = AntModal.confirm;
export default LegacyModal;
export { LegacyModal };
//# sourceMappingURL=LegacyModal.js.map